module.exports = __webpack_public_path__ + "static/media/quem-somos-img.e68343ca.jpg";